import { IDataProviderFilter } from 'core-components/types'
import { specializationApi, TSaveSpecialization } from 'onboarding/api/specializationApi'

class SpecializationService {
  public getListProgramElementsCrud(crudKey?: string) {
    return specializationApi.getListProgramElementsCrud(crudKey)
  }

  public clearCacheListProgramElementsCrud(crudKey?: string, needTriggerSubscribers?: boolean) {
    specializationApi.clearCacheListProgramElementsCrud(crudKey, needTriggerSubscribers)
  }

  public listProgramElements(filter: IDataProviderFilter) {
    return specializationApi.listProgramElements(filter)
  }

  public create(payload: TSaveSpecialization) {
    return specializationApi.create(payload)
  }

  public update(id: number, payload: TSaveSpecialization) {
    return specializationApi.update(id, payload)
  }

  public deleteOne(id: number): Promise<boolean> {
    return specializationApi.deleteOne(id)
  }
}

export const specializationService = new SpecializationService()
